module.exports = __webpack_public_path__ + "static/media/zeroe01.8fbb1c03.png";